document.documentElement.classList.remove('no-js');

function formatMoney(cents, format) {
  const value = (Math.round(cents) / 100).toFixed(2);
  const fmt = format || '${{amount}}';
  if (fmt.indexOf('{{amount}}') !== -1) return fmt.replace('{{amount}}', value);
  if (fmt.indexOf('{{amount_no_decimals}}') !== -1) return fmt.replace('{{amount_no_decimals}}', String(Math.round(cents / 100)));
  return '$' + value;
}

function offerPriceCents(regular, qty, packPct, subPct) {
  const count = Math.max(1, Number(qty) || 1);
  const off = Math.max(0, Number(packPct || 0)) + Math.max(0, Number(subPct || 0));
  const bounded = Math.min(100, off);
  return Math.round(Number(regular || 0) * count * (100 - bounded) / 100);
}

document.addEventListener('DOMContentLoaded', () => {
  initHeaderMenu();

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const wrap = select.closest('[data-product-form]');
      if (wrap && option.dataset.price) wrap.dataset.unitCents = option.dataset.price;
      if (wrap && option.dataset.compare) wrap.dataset.compareCents = option.dataset.compare;
      const btn = document.querySelector('[data-add-to-cart]');
      if (btn) {
        const available = option.dataset.available === 'true';
        btn.disabled = !available;
        if (!available) btn.textContent = 'Sold out';
      }
      if (wrap) {
        updatePackUI(wrap);
        syncProductFormState(wrap);
      }
    });
  });

  document.querySelectorAll('[data-product-form]').forEach(initProductForm);

  document.querySelectorAll('[data-ba-slider]').forEach(initBaSlider);

  const quiz = document.querySelector('[data-skin-quiz]');
  if (quiz) initQuiz(quiz);

  document.querySelectorAll('[data-product-gallery]').forEach(initGallery);

  document.querySelectorAll('[data-ing-showcase]').forEach(initIngShowcase);
  document.querySelectorAll('[data-reviews]').forEach(initReviews);
  initScrollReveal();
  initBackToStore();
  initCartDrawer();
  initUrgencyViewers();
  initReviewTickers();
  initSaleCountdown();
  initReviewForm();
  initTallowStickyCart();
  hideBundlerVolumeUpsell();
});

function hideBundlerVolumeUpsell() {
  if (!document.body.classList.contains('template-product')) return;

  const hide = () => {
    document.querySelectorAll('.bundler-volume-target-element, .bndlr-automatic-volume-bundle, .bndlr-volume, [id^="_bndl_"]').forEach((el) => {
      if (el.getAttribute('data-vy-hidden') === 'true') return;
      el.setAttribute('data-vy-hidden', 'true');
      el.hidden = true;
      el.style.setProperty('display', 'none', 'important');
    });
  };

  hide();
  const observer = new MutationObserver(hide);
  observer.observe(document.body, { childList: true, subtree: true });
}

function initHeaderMenu() {
  const toggle = document.querySelector('[data-mobile-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (!toggle || !menu) return;

  const setOpen = (open) => {
    menu.classList.toggle('open', open);
    toggle.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Close shop menu' : 'Open shop menu');
  };

  toggle.addEventListener('click', (event) => {
    event.stopPropagation();
    setOpen(!menu.classList.contains('open'));
  });

  document.addEventListener('click', (event) => {
    if (!menu.classList.contains('open')) return;
    if (event.target.closest('[data-mobile-menu], [data-mobile-menu-toggle]')) return;
    setOpen(false);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setOpen(false);
  });

  menu.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => setOpen(false));
  });
}

const URGENCY_LANES = ['clearbalance', 'hydrabalance', 'dewdrop', 'tallow'];
const URGENCY_MIN = 5;
const URGENCY_SPAN = 11;
const URGENCY_OFFSETS = [0, 3, 6, 8];
const URGENCY_PHASES = [3000, 4000, 5000];
const URGENCY_CYCLE = URGENCY_PHASES.reduce((sum, ms) => sum + ms, 0);

function urgencyCountsForEpoch(epoch) {
  const spin = ((epoch * 7) % URGENCY_SPAN + URGENCY_SPAN) % URGENCY_SPAN;
  return URGENCY_OFFSETS.map((off) => URGENCY_MIN + ((spin + off) % URGENCY_SPAN));
}

function urgencyEpochState(now) {
  const origin = Math.floor(now / URGENCY_CYCLE) * URGENCY_PHASES.length;
  const inCycle = now % URGENCY_CYCLE;
  let elapsed = 0;
  for (let i = 0; i < URGENCY_PHASES.length; i += 1) {
    const end = elapsed + URGENCY_PHASES[i];
    if (inCycle < end) {
      return { epoch: origin + i, remaining: end - inCycle };
    }
    elapsed = end;
  }
  return { epoch: origin, remaining: URGENCY_PHASES[0] };
}

function urgencyCountForLane(lane, epoch) {
  const counts = urgencyCountsForEpoch(epoch);
  const idx = URGENCY_LANES.indexOf(lane);
  return counts[idx >= 0 ? idx : 0];
}

function initUrgencyViewers(root) {
  const scope = root || document;
  scope.querySelectorAll('[data-urgency-viewers]').forEach((el) => {
    if (el.dataset.vyUrgencyBound === 'true') return;
    el.dataset.vyUrgencyBound = 'true';
    const countEl = el.querySelector('[data-urgency-count]');
    if (!countEl) return;
    const lane = el.dataset.urgencyLane || 'tallow';
    const tick = () => {
      const { epoch, remaining } = urgencyEpochState(Date.now());
      countEl.textContent = String(urgencyCountForLane(lane, epoch));
      window.setTimeout(tick, Math.max(250, remaining));
    };
    tick();
  });
}

function formatReviewCount(n, useComma) {
  const raw = String(n);
  return useComma ? raw.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : raw;
}

function initReviewTickers(root) {
  const scope = root || document;
  scope.querySelectorAll('[data-review-ticker]').forEach((el) => {
    if (el.dataset.vyReviewBound === 'true') return;
    el.dataset.vyReviewBound = 'true';
    const base = Number(el.dataset.reviewBase || 0);
    const step = Number(el.dataset.reviewStep || 3);
    const extras = Number(el.dataset.reviewExtras || 0);
    const start = Date.parse(el.dataset.reviewStart || '2026-09-10T00:00:00Z');
    const template = el.dataset.reviewTemplate || '{n}';
    const useComma = el.dataset.reviewComma === 'true';
    const ariaTemplate = el.dataset.reviewAria || '';
    if (!Number.isFinite(start) || !Number.isFinite(base)) return;
    const sessionBonus = () => {
      try {
        return Number(window.sessionStorage.getItem('vy-review-bonus') || 0);
      } catch (err) {
        return 0;
      }
    };
    const render = () => {
      const days = Math.max(0, Math.floor((Date.now() - start) / 86400000));
      const formatted = formatReviewCount(base + days * step + extras + sessionBonus(), useComma);
      el.textContent = template.replace(/\{n\}/g, formatted);
      if (ariaTemplate) {
        const host = el.closest('[data-review-aria-host]') || el;
        host.setAttribute('aria-label', ariaTemplate.replace(/\{n\}/g, formatted));
      }
    };
    render();
    const schedule = () => {
      const days = Math.max(0, Math.floor((Date.now() - start) / 86400000));
      const nextAt = start + (days + 1) * 86400000;
      window.setTimeout(() => {
        render();
        schedule();
      }, Math.max(1000, nextAt - Date.now()));
    };
    schedule();
  });
}

function initSaleCountdown(root) {
  const scope = root || document;
  const palettes = [
    ['#7b2dff', '#e11d8f'],
    ['#ff2d55', '#ff7a18'],
    ['#00b4ff', '#2563ff'],
    ['#22c55e', '#06b6d4'],
    ['#f43f5e', '#f97316']
  ];
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  scope.querySelectorAll('[data-sale-countdown]').forEach((bar) => {
    if (bar.dataset.vySaleBound === 'true') return;
    bar.dataset.vySaleBound = 'true';
    const hoursEl = bar.querySelector('[data-sale-h]');
    const minsEl = bar.querySelector('[data-sale-m]');
    const secsEl = bar.querySelector('[data-sale-s]');
    if (!hoursEl || !minsEl || !secsEl) return;
    const hours = Math.max(1, Number(bar.dataset.saleHours || 99) || 99);
    const cycle = hours * 3600 * 1000;
    const start = Date.parse(bar.dataset.saleStart || '2026-10-02T17:33:00Z');
    const end = Number.isFinite(start) ? start + cycle : 0;
    try {
      window.localStorage.removeItem('vyrelle_storewide_sale_end');
      window.localStorage.removeItem('vyrelle_countdown_end');
    } catch (err) {
      /* old per-browser timers should not keep running */
    }
    const remaining = () => {
      if (!end) return 0;
      return Math.max(0, end - Date.now());
    };
    const pad = (n) => String(n).padStart(2, '0');
    const render = () => {
      const diff = remaining();
      hoursEl.textContent = pad(Math.floor(diff / 3600000));
      minsEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
      secsEl.textContent = pad(Math.floor((diff % 60000) / 1000));
    };
    const washA = bar.querySelector('[data-sale-wash-a]');
    const washB = bar.querySelector('[data-sale-wash-b]');
    const paint = (el, palette) => {
      if (!el) return;
      el.style.background = 'linear-gradient(90deg, ' + palette[0] + ' 0%, ' + palette[1] + ' 100%)';
    };
    paint(washA, palettes[0]);
    paint(washB, palettes[1] || palettes[0]);
    if (!reduceMotion && washA && washB) {
      let index = 0;
      let showA = true;
      window.setInterval(() => {
        index = (index + 1) % palettes.length;
        const incoming = showA ? washB : washA;
        const outgoing = showA ? washA : washB;
        paint(incoming, palettes[index]);
        incoming.classList.add('is-on');
        outgoing.classList.remove('is-on');
        showA = !showA;
      }, 2400);
    }
    render();
    window.setInterval(render, 1000);
  });
}

function initReviewForm() {
  try {
    if (
      document.querySelector('[data-review-posted="contact"]') ||
      document.querySelector('[data-review-posted="comment-pending"]')
    ) {
      window.sessionStorage.setItem('vy-review-bonus', '1');
    }
  } catch (err) {
    /* ignore private-mode storage errors */
  }
  document.querySelectorAll('[data-review-form]').forEach((form) => {
    if (form.dataset.vyReviewFormBound === 'true') return;
    form.dataset.vyReviewFormBound = 'true';
    form.addEventListener('submit', () => {
      const rating = form.querySelector('input[name="contact[rating]"]:checked, input[name="comment[rating]"]:checked, input[name="rating"]:checked');
      const product = form.querySelector('[name="contact[product]"], [name="comment[product]"], [name="review_product"]');
      const title = form.querySelector('[name="contact[review_title]"], [name="comment[review_title]"], [name="review_title"]');
      const body = form.querySelector('[name="contact[body]"], [name="comment[body]"]');
      if (!body) return;
      const parts = [];
      if (rating) parts.push('Rating: ' + rating.value + '/5');
      if (product && product.value) parts.push('Product: ' + product.value);
      if (title && title.value) parts.push('Title: ' + title.value);
      if (parts.length) body.value = parts.join('\n') + '\n\n' + body.value;
    });
  });
}

function getProductForm(wrap) {
  return wrap.querySelector('form.vy-product-form') || wrap.querySelector('form[action*="/cart/add"]');
}

function isSubscribeSelected(wrap, form) {
  const toggle = wrap.querySelector('[data-selling-plan-toggle]');
  if (toggle) return toggle.checked;
  const sealSub = form.querySelector('input.sls-option[data-type="subscription"]');
  return !!(sealSub && sealSub.checked);
}

function normalizeSellingPlanId(value) {
  if (!value) return '';
  const str = String(value).trim();
  if (str === 'one_time') return '';
  const gid = str.match(/SellingPlan\/(\d+)/);
  if (gid) return gid[1];
  return str;
}

function readSellingPlanId(wrap, form) {
  if (!isSubscribeSelected(wrap, form)) return '';

  const interval = form.querySelector('[name="subs_interval"]');
  if (interval && interval.value) {
    const fromInterval = normalizeSellingPlanId(interval.value);
    if (fromInterval) return fromInterval;
  }

  const sealPlan = form.querySelector('input[data-sls-selling_plan]');
  if (sealPlan && sealPlan.value) {
    const fromSeal = normalizeSellingPlanId(sealPlan.value);
    if (fromSeal) return fromSeal;
  }

  const select = wrap.querySelector('[data-selling-plan-select]');
  if (select) {
    const fromSelect = normalizeSellingPlanId(select.value);
    if (fromSelect) return fromSelect;
    const firstPlan = [...select.options].find((option) => normalizeSellingPlanId(option.value));
    if (firstPlan) return normalizeSellingPlanId(firstPlan.value);
  }
  return '';
}

function applySellingPlanToForm(form, planId) {
  const sealInput = form.querySelector('input[data-sls-selling_plan]');
  const themeInput = form.querySelector('[data-theme-selling-plan]');
  const primary = sealInput || themeInput;

  form.querySelectorAll('[data-selling-plan-select], select[name="selling_plan"]').forEach((select) => {
    select.removeAttribute('name');
  });

  form.querySelectorAll('[name="selling_plan"]').forEach((field) => {
    if (field !== primary) {
      field.removeAttribute('name');
      field.disabled = true;
    }
  });

  if (!primary) return;

  if (planId) {
    primary.name = 'selling_plan';
    primary.disabled = false;
    primary.value = planId;
    if (sealInput) sealInput.setAttribute('data-sls-selling_plan', planId);
  } else {
    primary.value = '';
    primary.disabled = true;
  }
}

function syncSealWidget(wrap, form) {
  const toggle = wrap.querySelector('[data-selling-plan-toggle]');
  const subscribe = isSubscribeSelected(wrap, form);
  const subRadio = form.querySelector('input.sls-option[data-type="subscription"]');
  const oneRadio = form.querySelector('input.sls-option[data-type="one_time"]');
  const target = subscribe ? subRadio : oneRadio;
  if (target && !target.checked) target.click();
  if (toggle && subRadio) toggle.checked = subscribe;
}

function syncProductFormState(wrap) {
  const form = getProductForm(wrap);
  if (!form) return { id: '', quantity: 1, selling_plan: '' };

  const qtyInput = wrap.querySelector('[data-qty-input]') || form.querySelector('[name="quantity"]');
  const checked = wrap.querySelector('[name="vy_pack"]:checked');
  const quantity = checked ? Number(checked.value) || 1 : 1;
  if (qtyInput) {
    qtyInput.name = 'quantity';
    qtyInput.disabled = false;
    qtyInput.value = String(quantity);
  }

  const planSelect = wrap.querySelector('[data-selling-plan-select]');
  const toggle = wrap.querySelector('[data-selling-plan-toggle]');
  if (planSelect && toggle) {
    if (toggle.checked && !planSelect.value) {
      const firstPlan = [...planSelect.options].find((option) => option.value);
      if (firstPlan) planSelect.value = firstPlan.value;
    }
    if (!toggle.checked) planSelect.value = '';
  }

  syncSealWidget(wrap, form);
  const sellingPlan = readSellingPlanId(wrap, form);
  applySellingPlanToForm(form, sellingPlan);

  const idInput = form.querySelector('[name="id"]');
  return {
    id: idInput ? String(idInput.value) : '',
    quantity,
    selling_plan: sellingPlan
  };
}

function addToCartWithState(wrap, payload) {
  const qty = Number(payload.quantity);
  const unit = Number((wrap && wrap.dataset.unitCents) || 0);
  const packDiscount = Number((wrap && wrap.dataset.packDiscount) || 10);
  const subPct = Number((wrap && wrap.dataset.subDiscount) || 15);
  const item = {
    id: Number(payload.id),
    quantity: qty,
    properties: {
      _regular_cents: String(unit),
      _pack_discount: String(packDiscount),
      _sub_discount: String(payload.selling_plan ? subPct : 0)
    }
  };
  if (payload.selling_plan) {
    const plan = String(payload.selling_plan);
    item.selling_plan = /^\d+$/.test(plan) ? Number(plan) : plan;
  }

  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ items: [item] })
  }).then((response) => response.json().then((data) => {
    if (!response.ok || (data && data.status && Number(data.status) >= 400)) {
      const error = new Error((data && (data.description || data.message)) || 'Unable to add to cart');
      error.payload = data;
      throw error;
    }
    return data;
  })).then(() => {
    return refreshCartDrawer({ open: true }).catch(() => {
      window.location.href = '/cart';
    });
  }).then(() => {
    if (wrap) wrap.dataset.vySubmitting = 'false';
    const btn = wrap && wrap.querySelector('[data-add-to-cart]');
    if (btn) btn.disabled = false;
    if (wrap) updatePackUI(wrap);
  });
}

function initProductForm(wrap) {
  const form = getProductForm(wrap);
  if (!form) return;

  updatePackUI(wrap);
  syncProductFormState(wrap);

  if (wrap.dataset.vyProductBound === 'true') {
    bindSealListeners(wrap, form);
    return;
  }
  wrap.dataset.vyProductBound = 'true';

  wrap.querySelectorAll('[data-variant-pill]').forEach((pill) => {
    pill.addEventListener('click', () => {
      const select = wrap.querySelector('[data-variant-select]');
      if (!select || pill.disabled) return;
      select.value = pill.getAttribute('data-variant-id');
      wrap.querySelectorAll('[data-variant-pill]').forEach((item) => {
        item.classList.toggle('is-active', item === pill);
      });
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  wrap.addEventListener('change', (event) => {
    const target = event.target;
    if (!target) return;
    if (target.matches('[name="vy_pack"], [data-selling-plan-toggle], input.sls-option, [name="subs_interval"]')) {
      if (target.matches('input.sls-option')) {
        const toggle = wrap.querySelector('[data-selling-plan-toggle]');
        if (toggle) toggle.checked = target.getAttribute('data-type') === 'subscription' && target.checked;
      }
      updatePackUI(wrap);
      syncProductFormState(wrap);
    }
  });

  wrap.addEventListener('pointerdown', (event) => {
    if (event.target.closest('.shopify-payment-button, .shopify-payment-button__button, [name="add"]')) {
      updatePackUI(wrap);
      syncProductFormState(wrap);
    }
  }, true);

  bindSealListeners(wrap, form);

  const observer = new MutationObserver(() => {
    const nextForm = getProductForm(wrap);
    if (nextForm) bindSealListeners(wrap, nextForm);
  });
  observer.observe(wrap, { childList: true, subtree: true });
}

function bindSealListeners(wrap, form) {
  form.querySelectorAll('input.sls-option, [name="subs_interval"]').forEach((el) => {
    if (el.dataset.vySealBound === 'true') return;
    el.dataset.vySealBound = 'true';
    el.addEventListener('change', () => {
      const toggle = wrap.querySelector('[data-selling-plan-toggle]');
      if (toggle && el.matches('input.sls-option')) {
        toggle.checked = el.getAttribute('data-type') === 'subscription' && el.checked;
      }
      updatePackUI(wrap);
      syncProductFormState(wrap);
    });
  });
}

function updatePackUI(wrap) {
  const qtyInput = wrap.querySelector('[data-qty-input]');
  const checked = wrap.querySelector('[name="vy_pack"]:checked');
  const qty = checked ? Number(checked.value) : 1;
  if (qtyInput) {
    qtyInput.name = 'quantity';
    qtyInput.value = String(qty);
  }
  wrap.querySelectorAll('.vy-pack').forEach((pack) => {
    pack.classList.toggle('is-active', pack.querySelector('[name="vy_pack"]').checked);
  });
  const unit = Number(wrap.dataset.unitCents || 0);
  const compare = Number(wrap.dataset.compareCents || 0);
  const discount = Number(wrap.dataset.packDiscount || 10);
  const subPct = Number(wrap.dataset.subDiscount || 15);
  const packQty = Number(wrap.dataset.packQty || 2);
  const format = wrap.dataset.moneyFormat;
  const subToggle = wrap.querySelector('[data-selling-plan-toggle]');
  const subOn = !!(subToggle && subToggle.checked);
  const subCard = wrap.querySelector('.vy-subscribe-card');
  if (subCard) subCard.classList.toggle('is-on', subOn);

  const oneNow = offerPriceCents(unit, 1, 0, subOn ? subPct : 0);
  const twoNow = offerPriceCents(unit, packQty, discount, subOn ? subPct : 0);
  const packPct = qty >= packQty ? discount : 0;
  const total = offerPriceCents(unit, qty, packPct, subOn ? subPct : 0);
  const originalUnit = compare > unit ? compare : unit;
  const compareOneCents = originalUnit;
  const compareTwoCents = originalUnit * packQty;

  const priceOne = wrap.querySelector('[data-pack-price-one]');
  const compareOne = wrap.querySelector('[data-pack-compare-one]');
  if (priceOne) priceOne.textContent = formatMoney(oneNow, format);
  if (compareOne) {
    if (compareOneCents > oneNow) {
      compareOne.textContent = formatMoney(compareOneCents, format);
      compareOne.hidden = false;
    } else {
      compareOne.hidden = true;
    }
  }
  const priceTwo = wrap.querySelector('[data-pack-price-two]');
  const compareTwo = wrap.querySelector('[data-pack-compare-two]');
  if (priceTwo) priceTwo.textContent = formatMoney(twoNow, format);
  if (compareTwo) {
    if (compareTwoCents > twoNow) {
      compareTwo.textContent = formatMoney(compareTwoCents, format);
      compareTwo.hidden = false;
    } else {
      compareTwo.hidden = true;
    }
  }

  const offerNow = wrap.closest('.vy-product__buybox') && wrap.closest('.vy-product__buybox').querySelector('[data-offer-now]');
  const offerCompare = wrap.closest('.vy-product__buybox') && wrap.closest('.vy-product__buybox').querySelector('[data-offer-compare]');
  if (offerNow) offerNow.textContent = formatMoney(total, format);
  if (offerCompare) {
    const selectedCompare = qty * originalUnit;
    if (selectedCompare > total) {
      offerCompare.textContent = formatMoney(selectedCompare, format);
      offerCompare.hidden = false;
    } else {
      offerCompare.hidden = true;
    }
  }
  const offerSave = wrap.closest('.vy-product__buybox') && wrap.closest('.vy-product__buybox').querySelector('[data-offer-save]');
  if (offerSave) {
    const selectedCompare = qty * originalUnit;
    if (selectedCompare > total) {
      offerSave.textContent = 'Save ' + Math.round(((selectedCompare - total) * 100) / selectedCompare) + '%';
      offerSave.hidden = false;
    } else {
      offerSave.hidden = true;
    }
  }

  const btn = wrap.querySelector('[data-add-to-cart]');
  if (btn && !btn.disabled) btn.textContent = 'Add to bag • ' + formatMoney(total, format);
  document.querySelectorAll('[data-pdp-sticky-price], [data-tallow-sticky-price]').forEach((el) => {
    el.textContent = formatMoney(total, format);
  });
}

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-product-form]').forEach(initProductForm);
  event.target.querySelectorAll('[data-product-gallery]').forEach(initGallery);
  initUrgencyViewers(event.target);
  initReviewTickers(event.target);
  initSaleCountdown(event.target);
});

function escapeHtml(value) {
  return String(value || '').replace(/[&<>"']/g, (ch) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  }[ch]));
}

function cartMoney(cents, format) {
  return formatMoney(Number(cents || 0), format);
}

function cartItemQuantity(item) {
  return Math.max(1, Number(item.quantity || 1));
}

function cartItemRegularCents(item) {
  const props = item.properties || {};
  return Number(props._regular_cents || item.original_price || item.price || 0);
}

function cartItemCompareCents(item) {
  const plan = item.selling_plan_allocation || {};
  return Math.max(
    cartItemRegularCents(item),
    Number(item.compare_at_price || 0),
    Number(plan.compare_at_price || 0)
  );
}

function lineOfferState(item) {
  const qty = cartItemQuantity(item);
  const props = item.properties || {};
  const regular = cartItemRegularCents(item);
  const packRate = Number(props._pack_discount);
  const packPct = qty >= 2 ? (packRate > 0 ? packRate : 10) : 0;
  const hasSub = !!(item.selling_plan_allocation && item.selling_plan_allocation.selling_plan);
  const subRate = Number(props._sub_discount);
  const subPct = hasSub ? (subRate > 0 ? subRate : 15) : 0;
  const current = offerPriceCents(regular, qty, packPct, subPct);
  const was = cartItemCompareCents(item) * qty;
  return { current, was };
}

function cartLineShopifyPay(item) {
  const line = Number(item.final_line_price);
  if (Number.isFinite(line) && line >= 0) return line;
  return Number(item.line_price || 0);
}

function cartLineCurrentPrice(item) {
  const offered = lineOfferState(item).current;
  const shopify = cartLineShopifyPay(item);
  if (shopify > 0) return Math.min(offered, shopify);
  return offered;
}

function cartLineWasPrice(item) {
  const offered = lineOfferState(item);
  return Math.max(offered.was, offered.current);
}

function cartLineSaleSavings(item) {
  const qty = cartItemQuantity(item);
  return Math.max(0, (cartItemCompareCents(item) - cartItemRegularCents(item)) * qty);
}

function cartLineSavings(item) {
  return Math.max(0, cartLineWasPrice(item) - cartLineCurrentPrice(item));
}

function cartCouponCents(cart) {
  const line = (cart.items || []).reduce((sum, item) => {
    const listed = (item.discounts || []).reduce((total, disc) => total + Number(disc.amount || 0), 0);
    return sum + Math.max(
      Number(item.line_level_total_discount || 0),
      Number(item.total_discount || 0),
      listed
    );
  }, 0);
  const cartLevel = (cart.cart_level_discount_applications || []).reduce((sum, app) => {
    return sum + Number(app.total_allocated_amount || 0);
  }, 0);
  return Math.max(Number(cart.total_discount || 0), line + cartLevel);
}

function cartMerchandiseCents(cart) {
  const fromItems = (cart.items || []).reduce((sum, item) => sum + cartLineCurrentPrice(item), 0);
  const shopify = Number(cart.total_price || 0);
  if (shopify > 0) return Math.min(fromItems || shopify, shopify);
  return fromItems;
}

function cartSavingsBreakdown(cart) {
  const items = cart.items || [];
  const was = items.reduce((sum, item) => sum + cartLineWasPrice(item), 0);
  const pay = cartMerchandiseCents(cart);
  const sale = items.reduce((sum, item) => sum + cartLineSaleSavings(item), 0);
  const coupon = cartCouponCents(cart);
  const total = Math.max(0, was - pay, sale + coupon);
  return { sale, coupon, total, pay, was };
}

function cartTotalSavings(cart) {
  return cartSavingsBreakdown(cart).total;
}

function renderCartItems(cart, format) {
  return (cart.items || []).map((item) => {
    const current = cartLineCurrentPrice(item);
    const compare = cartLineWasPrice(item);
    const saved = cartLineSavings(item);
    const savePct = compare > current ? Math.round(((compare - current) * 100) / compare) : 0;
    const image = item.image || (item.featured_image && item.featured_image.url) || '';
    const plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
    const planName = plan && (plan.name || 'Monthly delivery');
    return `
      <article class="vy-drawer__item" data-line-key="${escapeHtml(item.key)}">
        ${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(item.product_title || item.title)}" width="72" height="72">` : '<div class="vy-drawer__item-ph"></div>'}
        <div class="vy-drawer__item-info">
          <div class="vy-drawer__item-main">
            <a href="${escapeHtml(item.url || '#')}">${escapeHtml(item.product_title || item.title)}</a>
            ${plan ? `<span class="vy-drawer__sub-badge">Subscribe & save</span><span class="vy-drawer__plan">${escapeHtml(planName)}</span>` : ''}
            <div class="vy-drawer__price">
              ${compare > current ? `<s>${cartMoney(compare, format)}</s>` : ''}
              <strong>${cartMoney(current, format)}</strong>
              ${savePct > 0 ? `<span class="vy-price-with-save__off">Save ${savePct}%</span>` : ''}
            </div>
            ${saved > 0 ? `<p class="vy-drawer__save">You save ${cartMoney(saved, format)}</p>` : ''}
          </div>
          <div class="vy-drawer__qty-row">
            <div class="vy-drawer__qty">
              <button type="button" data-cart-qty="-1" aria-label="Decrease quantity">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-cart-qty="1" aria-label="Increase quantity">+</button>
            </div>
            <button type="button" class="vy-drawer__remove" data-cart-remove aria-label="Remove ${escapeHtml(item.product_title || item.title)}">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 7h14M10 7V5h4v2m-7 3v8m6-8v8M7 7l1 13h8l1-13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </button>
          </div>
        </div>
      </article>
    `;
  }).join('');
}

function updateHeaderCartCount(count) {
  document.querySelectorAll('[data-cart-count]').forEach((el) => {
    el.textContent = String(count);
    if (el.classList.contains('vy-cart-count')) el.hidden = count < 1;
  });
  document.querySelectorAll('[data-cart-open]').forEach((el) => {
    if (el.classList.contains('vy-cart-link')) {
      el.setAttribute('aria-label', 'Cart, ' + count + ' items');
    }
  });
}

function cartShippingCents(merchandise, threshold, rate) {
  const subtotal = Number(merchandise || 0);
  if (subtotal <= 0) return 0;
  if (subtotal >= Number(threshold || 0)) return 0;
  return Math.max(0, Number(rate || 0));
}

function renderCartDrawer(cart) {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer || !cart) return;
  const format = drawer.dataset.moneyFormat;
  const count = Number(cart.item_count || 0);
  const empty = drawer.querySelector('[data-cart-empty]');
  const content = drawer.querySelector('[data-cart-content]');
  const badge = drawer.querySelector('[data-cart-badge]');
  const items = drawer.querySelector('[data-cart-items]');
  const subtotal = drawer.querySelector('[data-cart-subtotal]');
  const savings = drawer.querySelector('[data-cart-savings]');
  const savingsRow = drawer.querySelector('[data-cart-savings-row]');
  const savingsDetail = drawer.querySelector('[data-cart-savings-detail]');
  const shippingAmount = drawer.querySelector('[data-cart-shipping-amount]');
  const saveNote = drawer.querySelector('[data-cart-save-note]');
  const checkout = drawer.querySelector('[data-cart-checkout]');
  const shipCopy = drawer.querySelector('[data-cart-shipping-copy]');
  const shipBar = drawer.querySelector('[data-cart-shipping-bar]');
  const threshold = Number(drawer.dataset.freeShipping || 6000);
  const shippingRate = Number(drawer.dataset.shippingCost || 499);
  const savingsParts = cartSavingsBreakdown(cart);
  const merchandise = savingsParts.pay || Number(cart.total_price || 0);
  const shipping = cartShippingCents(merchandise, threshold, shippingRate);
  const checkoutTotal = merchandise + shipping;
  const discount = savingsParts.total;

  updateHeaderCartCount(count);
  if (badge) {
    badge.textContent = String(count);
    badge.hidden = count < 1;
  }
  if (empty) empty.hidden = count > 0;
  if (content) {
    content.hidden = count < 1;
    content.dataset.count = String((cart.items || []).length);
  }
  if (items) {
    items.innerHTML = renderCartItems(cart, format);
    items.dataset.count = String((cart.items || []).length);
  }
  if (subtotal) subtotal.textContent = cartMoney(merchandise, format);
  if (savings && savingsRow) {
    savings.textContent = cartMoney(discount, format);
    savingsRow.hidden = discount < 1;
  }
  if (savingsDetail) {
    const bits = [];
    if (savingsParts.sale > 0) bits.push(cartMoney(savingsParts.sale, format) + ' sale');
    if (savingsParts.coupon > 0) bits.push(cartMoney(savingsParts.coupon, format) + ' off');
    const extra = Math.max(0, discount - savingsParts.sale - savingsParts.coupon);
    if (extra > 0 && bits.length) bits.push(cartMoney(extra, format) + ' extra');
    savingsDetail.textContent = bits.length ? 'Includes ' + bits.join(' + ') : '';
    savingsDetail.hidden = bits.length < 1 || discount < 1;
  }
  if (shippingAmount) {
    shippingAmount.textContent = shipping > 0 ? cartMoney(shipping, format) : 'Free';
    shippingAmount.classList.toggle('is-free', shipping < 1);
  }
  if (saveNote) {
    saveNote.textContent = discount > 0 ? 'You save ' + cartMoney(discount, format) : '';
    saveNote.hidden = discount < 1;
  }
  if (checkout) checkout.textContent = 'Checkout • ' + cartMoney(checkoutTotal, format);
  if (shipCopy && shipBar) {
    if (threshold <= 0) {
      shipBar.style.width = '100%';
      shipCopy.textContent = 'Free standard U.S. shipping on every order';
    } else {
      const remaining = Math.max(0, threshold - merchandise);
      const pct = Math.min(100, (merchandise / threshold) * 100);
      shipBar.style.width = pct + '%';
      shipCopy.textContent = remaining > 0
        ? 'Add ' + cartMoney(remaining, format) + ' to unlock free shipping'
        : 'Free shipping unlocked';
    }
  }
}

function fetchCart() {
  return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json());
}

function changeCartLine(key, quantity) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ id: key, quantity: Number(quantity) })
  }).then((response) => response.json()).then(renderCartDrawer);
}

function showCartDrawer() {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  document.body.classList.add('vy-drawer-open');
  const panel = drawer.querySelector('.vy-drawer__panel');
  if (panel) panel.focus();
}

function hideCartDrawer() {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('vy-drawer-open');
}

function refreshCartDrawer(options) {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) {
    window.location.href = '/cart';
    return Promise.resolve();
  }
  return fetchCart().then((cart) => {
    renderCartDrawer(cart);
    if (options && options.open) showCartDrawer();
    return cart;
  });
}

function initCartDrawer() {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  document.querySelectorAll('[data-cart-open]').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      const menu = document.querySelector('[data-mobile-menu]');
      const toggle = document.querySelector('[data-mobile-menu-toggle]');
      if (menu) menu.classList.remove('open');
      if (toggle) {
        toggle.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open shop menu');
      }
      refreshCartDrawer({ open: true });
    });
  });

  drawer.addEventListener('click', (event) => {
    const checkout = event.target.closest('[data-cart-checkout], [data-cart-checkout-form]');
    if (checkout) {
      event.preventDefault();
      event.stopPropagation();
      const url = (drawer.getAttribute('data-checkout-url') || '').trim() || '/checkout';
      window.location.assign(url);
      return;
    }
    if (event.target.closest('[data-cart-close]')) {
      hideCartDrawer();
      return;
    }
    const item = event.target.closest('[data-line-key]');
    if (!item) return;
    const key = item.getAttribute('data-line-key');
    if (event.target.closest('[data-cart-remove]')) {
      changeCartLine(key, 0);
      return;
    }
    const qtyBtn = event.target.closest('[data-cart-qty]');
    if (qtyBtn) {
      const current = Number((item.querySelector('.vy-drawer__qty span') || {}).textContent || 1);
      const next = Math.max(0, current + Number(qtyBtn.getAttribute('data-cart-qty') || 0));
      changeCartLine(key, next);
    }
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) hideCartDrawer();
  });
}

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!form || !form.classList || !form.classList.contains('vy-product-form')) return;
  if (event.submitter && event.submitter.closest('.shopify-payment-button')) return;

  const wrap = form.closest('[data-product-form]');
  if (!wrap || wrap.dataset.vySubmitting === 'true') return;

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  updatePackUI(wrap);
  const payload = syncProductFormState(wrap);
  const btn = wrap.querySelector('[data-add-to-cart]');
  wrap.dataset.vySubmitting = 'true';
  if (btn) btn.disabled = true;

  addToCartWithState(wrap, payload).catch(() => {
    wrap.dataset.vySubmitting = 'false';
    if (btn) btn.disabled = false;
    HTMLFormElement.prototype.submit.call(form);
  });
}, true);

const vyRevealObserved = new WeakSet();

function collectRevealTargets() {
  const targets = [];
  const seen = new Set();
  const add = (el) => {
    if (!el || seen.has(el)) return;
    seen.add(el);
    targets.push(el);
  };

  document.querySelectorAll('[data-vy-reveal]').forEach(add);

  document.querySelectorAll('#MainContent .shopify-section').forEach((wrap) => {
    if (wrap.querySelector('[data-vy-reveal]')) return;
    if (wrap.querySelector('.vy-marquee, .vy-announcement')) return;
    add(wrap.firstElementChild || wrap);
  });

  return targets;
}

function isInViewport(el) {
  const rect = el.getBoundingClientRect();
  const vh = window.innerHeight || document.documentElement.clientHeight || 0;
  return rect.top < vh * 0.88 && rect.bottom > 40;
}

function revealEl(el) {
  if (el.classList.contains('vy-revealed')) return;
  el.classList.add('vy-revealed');
  const done = () => el.classList.remove('vy-will-reveal');
  el.addEventListener('transitionend', done, { once: true });
  setTimeout(done, 800);
}

function initScrollReveal() {
  let nodes = [];
  try {
    nodes = collectRevealTargets().filter((el) => !vyRevealObserved.has(el));
  } catch (e) {
    return;
  }
  if (!nodes.length) return;

  nodes.forEach((el) => vyRevealObserved.add(el));

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    nodes.forEach((el) => el.classList.add('vy-revealed'));
    return;
  }

  try {
    nodes.forEach((el) => {
      const parent = el.parentElement;
      const siblings = parent ? [...parent.children].filter((child) => nodes.includes(child)) : [el];
      const index = Math.max(0, siblings.indexOf(el));
      el.style.setProperty('--vy-reveal-delay', Math.min(index * 90, 360) + 'ms');
      el.classList.add('vy-will-reveal');
    });

    const run = () => {
      nodes.forEach((el) => {
        if (isInViewport(el)) revealEl(el);
      });
    };

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        run();
        window.addEventListener('scroll', run, { passive: true });
        window.addEventListener('resize', run);
        if (!('IntersectionObserver' in window)) return;
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            revealEl(entry.target);
            io.unobserve(entry.target);
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -12% 0px' });
        nodes.forEach((el) => {
          if (!el.classList.contains('vy-revealed')) io.observe(el);
        });
      });
    });
  } catch (e) {
    nodes.forEach((el) => el.classList.remove('vy-will-reveal'));
  }
}

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-ing-showcase]').forEach(initIngShowcase);
  event.target.querySelectorAll('[data-reviews]').forEach(initReviews);
  initScrollReveal();
});

function initIngShowcase(root) {
  const viewport = root.querySelector('.vy-ing-carousel__viewport');
  const track = root.querySelector('[data-ing-track]');
  const cards = [...root.querySelectorAll('[data-ing-card]')];
  const dotsWrap = root.querySelector('[data-ing-dots]');
  const prev = root.querySelector('[data-ing-prev]');
  const next = root.querySelector('[data-ing-next]');
  if (!viewport || !track || !cards.length) return;

  let index = 0;
  const gap = 16;
  const perView = () => {
    const w = window.innerWidth;
    if (w < 780) return 1;
    if (w < 1100) return 2;
    return 3;
  };
  const maxIndex = () => Math.max(0, cards.length - perView());

  const paint = () => {
    const cardWidth = cards[0].getBoundingClientRect().width;
    const x = index * (cardWidth + gap);
    track.style.transform = 'translateX(-' + x + 'px)';
    cards.forEach((card, i) => card.classList.toggle('is-active', i === index));
    if (dotsWrap) {
      [...dotsWrap.children].forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    }
    if (prev) prev.disabled = index <= 0;
    if (next) next.disabled = index >= maxIndex();
  };

  if (dotsWrap && !dotsWrap.childElementCount) {
    cards.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', 'Show ingredient ' + (i + 1));
      dot.addEventListener('click', () => {
        index = Math.min(i, maxIndex());
        paint();
      });
      dotsWrap.appendChild(dot);
    });
  }

  prev?.addEventListener('click', () => {
    index = Math.max(0, index - 1);
    paint();
  });
  next?.addEventListener('click', () => {
    index = Math.min(maxIndex(), index + 1);
    paint();
  });
  window.addEventListener('resize', () => {
    index = Math.min(index, maxIndex());
    paint();
  });
  paint();
}

function initGallery(root) {
  if (!root || root.dataset.vyGalleryBound === 'true') return;
  const slides = [...root.querySelectorAll('[data-gallery-slide]')];
  const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
  if (slides.length < 2) return;
  root.dataset.vyGalleryBound = 'true';
  let index = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
  let timer = 0;
  const delay = 4000;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const show = (i) => {
    index = (i + slides.length) % slides.length;
    slides.forEach((slide, n) => slide.classList.toggle('is-active', n === index));
    thumbs.forEach((thumb, n) => thumb.classList.toggle('is-active', n === index));
  };
  const stop = () => {
    if (timer) window.clearInterval(timer);
    timer = 0;
  };
  const start = () => {
    stop();
    if (reduceMotion) return;
    timer = window.setInterval(() => show(index + 1), delay);
  };
  root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => {
    show(index - 1);
    start();
  });
  root.querySelector('[data-gallery-next]')?.addEventListener('click', () => {
    show(index + 1);
    start();
  });
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      show(Number(thumb.dataset.index));
      start();
    });
  });
  root.addEventListener('mouseenter', stop);
  root.addEventListener('mouseleave', start);
  root.addEventListener('focusin', stop);
  root.addEventListener('focusout', (event) => {
    if (!root.contains(event.relatedTarget)) start();
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stop();
    else start();
  });
  start();
}

function initBaSlider(slider) {
  const setPos = (value) => {
    const pct = Math.max(0, Math.min(100, Number(value)));
    slider.style.setProperty('--pos', pct + '%');
    slider.setAttribute('aria-valuenow', String(Math.round(pct)));
  };

  const posFromEvent = (event) => {
    const point = event.touches ? event.touches[0] : event;
    if (!point) return;
    const rect = slider.getBoundingClientRect();
    if (!rect.width) return;
    setPos(((point.clientX - rect.left) / rect.width) * 100);
  };

  setPos(50);

  slider.addEventListener('pointerdown', (event) => {
    if (event.button != null && event.button !== 0) return;
    slider.classList.add('is-dragging');
    try {
      slider.setPointerCapture(event.pointerId);
    } catch (e) {
      /* Older browsers without capture still get pointermove on the slider. */
    }
    posFromEvent(event);
    event.preventDefault();
  });

  slider.addEventListener('pointermove', (event) => {
    if (!slider.classList.contains('is-dragging')) return;
    posFromEvent(event);
  });

  const stopDrag = () => slider.classList.remove('is-dragging');
  slider.addEventListener('pointerup', stopDrag);
  slider.addEventListener('pointercancel', stopDrag);

  slider.addEventListener('keydown', (event) => {
    const now = Number(slider.getAttribute('aria-valuenow') || 50);
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      setPos(now - 5);
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      setPos(now + 5);
    } else if (event.key === 'Home') {
      event.preventDefault();
      setPos(0);
    } else if (event.key === 'End') {
      event.preventDefault();
      setPos(100);
    }
  });
}

function initQuiz(root) {
  const form = root.querySelector('[data-quiz-form]');
  const result = root.querySelector('[data-quiz-result]');
  const legend = root.querySelector('[data-quiz-legend]');
  const optionsEl = root.querySelector('[data-quiz-options]');
  const progress = root.querySelector('[data-quiz-progress]');
  const bar = root.querySelector('[data-quiz-bar]');
  const nextBtn = root.querySelector('[data-quiz-next]');
  const backBtn = root.querySelector('[data-quiz-back]');
  const resetBtn = root.querySelector('[data-quiz-reset]');
  const resultBackBtn = root.querySelector('[data-quiz-result-back]');
  const resultText = root.querySelector('[data-quiz-result-text]');
  const resultLink = root.querySelector('[data-quiz-result-link]');
  let config = {};
  try {
    config = JSON.parse(root.querySelector('[data-quiz-config]').textContent);
  } catch (e) {
    config = {};
  }

  const total = 4;
  let step = 1;
  const answers = {};
  const products = ['dewdrop', 'tallow', 'clearbalance', 'hydrabalance'];
  const goalPrimary = {
    hydrate: 'dewdrop',
    lock: 'tallow',
    cleanse: 'clearbalance',
    light: 'hydrabalance'
  };

  const q1 = {
    legend: 'What is your main skin goal?',
    options: [
      { id: 'hydrate', label: 'Hydration that lasts past the first few minutes', add: { dewdrop: 3 } },
      { id: 'lock', label: 'Soften rough, dry skin and lock moisture in', add: { tallow: 3 } },
      { id: 'cleanse', label: 'A comfortable cleanse that does not leave skin tight', add: { clearbalance: 3 } },
      { id: 'light', label: 'Lightweight moisture that does not feel heavy', add: { hydrabalance: 3, dewdrop: 1 } }
    ]
  };

  const describeByGoal = {
    hydrate: {
      legend: 'How would you describe your skin?',
      options: [
        { id: 'dull', label: 'Looks dull again minutes after moisturizing', add: { dewdrop: 3 } },
        { id: 'thirsty', label: 'Feels thirsty under makeup', add: { dewdrop: 2, hydrabalance: 1 } },
        { id: 'combo', label: 'Tight in some places, shiny in others', add: { hydrabalance: 2, dewdrop: 1 } },
        { id: 'normal-dew', label: 'Normal — I just want a dewy layer', add: { dewdrop: 2 } }
      ]
    },
    lock: {
      legend: 'How would you describe your skin?',
      options: [
        { id: 'dry-tight', label: 'Dry and tight through the day', add: { tallow: 3 } },
        { id: 'rough', label: 'Rough, dry, and moisture slips away', add: { tallow: 3 } },
        { id: 'stripped', label: 'Easily stripped or sensitive-feeling', add: { tallow: 2, hydrabalance: 1 } },
        { id: 'night-dry', label: 'Drier at night than during the day', add: { tallow: 3, dewdrop: 1 } }
      ]
    },
    cleanse: {
      legend: 'How would you describe your skin?',
      options: [
        { id: 'tight-wash', label: 'Tight right after I wash my face', add: { clearbalance: 3 } },
        { id: 'coated', label: 'Feels coated or stripped by my cleanser', add: { clearbalance: 3 } },
        { id: 'combo-clean', label: 'Tight after washing, then shiny later', add: { clearbalance: 2, hydrabalance: 2 } },
        { id: 'unsure-clean', label: 'Not sure — I just want a gentler wash', add: { clearbalance: 2 } }
      ]
    },
    light: {
      legend: 'How would you describe your skin?',
      options: [
        { id: 'dehydrated', label: 'Dehydrated, but not dry', add: { hydrabalance: 2, dewdrop: 2 } },
        { id: 'shiny', label: 'Looks shiny by midday', add: { hydrabalance: 3 } },
        { id: 'normal-light', label: 'Normal — I want something that disappears', add: { hydrabalance: 2, dewdrop: 1 } },
        { id: 'patches', label: 'Dry in patches, heavy creams feel like too much', add: { hydrabalance: 2, dewdrop: 1 } }
      ]
    }
  };

  const formulaByGoal = {
    hydrate: {
      legend: 'What kind of formula are you looking for?',
      options: [
        { id: 'serum', label: 'A lightweight serum to layer under moisturizer', add: { dewdrop: 3 } },
        { id: 'gel', label: 'A gel-cream that feels light', add: { hydrabalance: 3 } },
        { id: 'serum-then-cream', label: 'Serum first, then a richer cream', add: { dewdrop: 2, tallow: 2 } },
        { id: 'unsure-hydrate', label: 'Not sure — keep it simple', add: { dewdrop: 2 } }
      ]
    },
    lock: {
      legend: 'What kind of formula are you looking for?',
      options: [
        { id: 'rich', label: 'A richer cream that lasts, especially at night', add: { tallow: 3 } },
        { id: 'simple-natural', label: 'Something simple and natural', add: { tallow: 2 } },
        { id: 'serum-under', label: 'A serum first, then cream', add: { dewdrop: 2, tallow: 2 } },
        { id: 'lighter-than-cream', label: 'Lighter than a heavy cream', add: { hydrabalance: 2, dewdrop: 1 } }
      ]
    },
    cleanse: {
      legend: 'What kind of formula are you looking for?',
      options: [
        { id: 'gel-cleanser', label: 'A gentle gel cleanser', add: { clearbalance: 3 } },
        { id: 'cleanse-hydrate', label: 'A cleanser, then lightweight moisture', add: { clearbalance: 2, hydrabalance: 2 } },
        { id: 'cleanse-rich', label: 'A cleanser, then a richer cream', add: { clearbalance: 2, tallow: 2 } },
        { id: 'unsure-formula-clean', label: 'Not sure — keep it simple', add: { clearbalance: 2 } }
      ]
    },
    light: {
      legend: 'What kind of formula are you looking for?',
      options: [
        { id: 'gel-cream', label: 'A gel-cream that does not feel heavy', add: { hydrabalance: 3 } },
        { id: 'light-serum', label: 'A lightweight serum', add: { dewdrop: 3 } },
        { id: 'night-only-rich', label: 'Something richer, but only at night', add: { tallow: 2, hydrabalance: 1 } },
        { id: 'unsure-light', label: 'Not sure — keep it simple', add: { hydrabalance: 2 } }
      ]
    }
  };

  const followUpByLead = {
    dewdrop: {
      legend: 'How do you want to use that hydration?',
      options: [
        { id: 'under-cream', label: 'Under my moisturizer', add: { dewdrop: 3 } },
        { id: 'solo-am', label: 'On its own in the morning', add: { dewdrop: 2 } },
        { id: 'am-pm', label: 'Morning and night', add: { dewdrop: 2 } },
        { id: 'unsure-use', label: 'Not sure', add: { dewdrop: 1 } }
      ]
    },
    tallow: {
      legend: 'When do you want that richer layer?',
      options: [
        { id: 'night', label: 'At night, when skin feels driest', add: { tallow: 3 } },
        { id: 'day-night', label: 'Day and night', add: { tallow: 2 } },
        { id: 'after-serum', label: 'After a hydrating serum', add: { tallow: 2, dewdrop: 2 } },
        { id: 'unsure-when', label: 'Not sure', add: { tallow: 1 } }
      ]
    },
    clearbalance: {
      legend: 'What bothers you most after washing?',
      options: [
        { id: 'tightness', label: 'Tightness', add: { clearbalance: 3 } },
        { id: 'residue', label: 'A coated or stripped feeling', add: { clearbalance: 3 } },
        { id: 'both-wash', label: 'Both', add: { clearbalance: 2, hydrabalance: 1 } },
        { id: 'unsure-after', label: 'Not sure', add: { clearbalance: 1 } }
      ]
    },
    hydrabalance: {
      legend: 'How do heavier creams usually feel on you?',
      options: [
        { id: 'too-heavy', label: 'Too heavy or shiny', add: { hydrabalance: 3 } },
        { id: 'night-ok', label: 'Fine at night, too much by day', add: { hydrabalance: 2, tallow: 1 } },
        { id: 'need-lighter', label: 'I still want something lighter', add: { hydrabalance: 2, dewdrop: 1 } },
        { id: 'unsure-feel', label: 'Not sure', add: { hydrabalance: 1 } }
      ]
    }
  };

  const resultCopy = {
    dewdrop: (title) =>
      'Based on your answers, ' + title + ' is a good match for skin that looks dull again minutes after moisturizing — a lightweight serum to hydrate before cream.',
    tallow: (title) =>
      'Based on your answers, ' + title + ' is a good match for rough, dry skin that moisture keeps escaping from — a richer layer that helps lock moisture in, especially at night.',
    clearbalance: (title) =>
      'Based on your answers, ' + title + ' is a good match when washing leaves skin tight — a comfortable cleanse that does not strip.',
    hydrabalance: (title) =>
      'Based on your answers, ' + title + ' is a good match for skin that wants moisture without a heavy feel.'
  };

  const goalOf = () => (answers[1] && answers[1].id) || 'hydrate';

  const tally = (throughStep) => {
    const scores = { dewdrop: 0, tallow: 0, clearbalance: 0, hydrabalance: 0 };
    for (let i = 1; i <= throughStep; i += 1) {
      const add = answers[i] && answers[i].add;
      if (!add) continue;
      products.forEach((key) => {
        if (add[key]) scores[key] += add[key];
      });
    }
    return scores;
  };

  const leadingKey = (throughStep) => {
    const scores = tally(throughStep);
    const fallback = goalPrimary[goalOf()] || 'dewdrop';
    let key = fallback;
    let best = scores[fallback] || 0;
    products.forEach((name) => {
      if (scores[name] > best) {
        best = scores[name];
        key = name;
      }
    });
    return key;
  };

  const formulaFor = (goal, skin) => {
    if (goal === 'hydrate' && skin === 'combo') {
      return {
        legend: 'What kind of formula are you looking for?',
        options: [
          { id: 'gel', label: 'A gel-cream that feels light', add: { hydrabalance: 3 } },
          { id: 'serum', label: 'A lightweight serum to layer under moisturizer', add: { dewdrop: 2 } },
          { id: 'serum-then-cream', label: 'Serum first, then a richer cream', add: { dewdrop: 1, tallow: 2 } },
          { id: 'unsure-hydrate', label: 'Not sure — keep it simple', add: { hydrabalance: 2, dewdrop: 1 } }
        ]
      };
    }
    if (goal === 'lock' && skin === 'stripped') {
      return {
        legend: 'What kind of formula are you looking for?',
        options: [
          { id: 'simple-natural', label: 'Something simple and natural', add: { tallow: 3 } },
          { id: 'lighter-than-cream', label: 'Lighter than a heavy cream', add: { hydrabalance: 2, dewdrop: 1 } },
          { id: 'rich', label: 'A richer cream that lasts, especially at night', add: { tallow: 2 } },
          { id: 'serum-under', label: 'A serum first, then cream', add: { dewdrop: 2, tallow: 1 } }
        ]
      };
    }
    if (goal === 'cleanse' && skin === 'combo-clean') {
      return {
        legend: 'What kind of formula are you looking for?',
        options: [
          { id: 'cleanse-hydrate', label: 'A cleanser, then lightweight moisture', add: { clearbalance: 2, hydrabalance: 3 } },
          { id: 'gel-cleanser', label: 'A gentle gel cleanser', add: { clearbalance: 3 } },
          { id: 'cleanse-rich', label: 'A cleanser, then a richer cream', add: { clearbalance: 1, tallow: 2 } },
          { id: 'unsure-formula-clean', label: 'Not sure — keep it simple', add: { clearbalance: 2, hydrabalance: 1 } }
        ]
      };
    }
    if (goal === 'light' && skin === 'shiny') {
      return {
        legend: 'What kind of formula are you looking for?',
        options: [
          { id: 'gel-cream', label: 'A gel-cream that does not feel heavy', add: { hydrabalance: 3 } },
          { id: 'light-serum', label: 'A lightweight serum', add: { dewdrop: 2 } },
          { id: 'night-only-rich', label: 'Something richer, but only at night', add: { tallow: 1, hydrabalance: 2 } },
          { id: 'unsure-light', label: 'Not sure — keep it simple', add: { hydrabalance: 2 } }
        ]
      };
    }
    return formulaByGoal[goal] || formulaByGoal.hydrate;
  };

  const questionFor = (n) => {
    if (n === 1) return q1;
    const goal = goalOf();
    if (n === 2) return describeByGoal[goal] || describeByGoal.hydrate;
    if (n === 3) return formulaFor(goal, answers[2] && answers[2].id);
    return followUpByLead[leadingKey(3)] || followUpByLead.dewdrop;
  };

  const selectedId = () => {
    const input = optionsEl.querySelector('input:checked');
    return input ? input.value : '';
  };

  const renderStep = () => {
    const question = questionFor(step);
    legend.textContent = question.legend;
    optionsEl.innerHTML = '';
    const saved = answers[step] && answers[step].id;
    const stillValid = question.options.some((opt) => opt.id === saved);
    question.options.forEach((opt, index) => {
      const label = document.createElement('label');
      label.className = 'vy-quiz__option';
      const input = document.createElement('input');
      input.type = 'radio';
      input.name = 'quiz-q' + step;
      input.value = opt.id;
      input.required = index === 0;
      if (stillValid && opt.id === saved) input.checked = true;
      const span = document.createElement('span');
      span.textContent = opt.label;
      label.appendChild(input);
      label.appendChild(span);
      optionsEl.appendChild(label);
    });
    if (progress) progress.textContent = 'Question ' + step + ' of ' + total;
    if (bar) bar.style.width = (step / total) * 100 + '%';
    if (backBtn) backBtn.disabled = step === 1;
    if (nextBtn) nextBtn.textContent = step === total ? 'See recommendation' : 'Next';
  };

  const showResult = () => {
    const key = leadingKey(4);
    const match = config[key] || config.dewdrop || {};
    const title = match.title || 'Dew Drop';
    const copy = (resultCopy[key] || resultCopy.dewdrop)(title);
    form.hidden = true;
    result.hidden = false;
    if (bar) bar.style.width = '100%';
    if (progress) progress.textContent = 'Your match';
    if (resultText) resultText.textContent = copy;
    if (resultLink) {
      resultLink.setAttribute('href', match.url || '/');
      resultLink.textContent = match.button || ('Shop ' + title);
    }
  };

  const hideResult = () => {
    result.hidden = true;
    form.hidden = false;
  };

  nextBtn?.addEventListener('click', () => {
    const id = selectedId();
    if (!id) return;
    const question = questionFor(step);
    const option = question.options.find((opt) => opt.id === id);
    if (!option) return;
    const previous = answers[step] && answers[step].id;
    answers[step] = { id: option.id, add: option.add };
    if (previous && previous !== option.id) {
      if (step === 1) {
        delete answers[2];
        delete answers[3];
        delete answers[4];
      } else if (step === 2) {
        delete answers[3];
        delete answers[4];
      } else if (step === 3) {
        delete answers[4];
      }
    }
    if (step < total) {
      step += 1;
      renderStep();
      return;
    }
    showResult();
  });

  backBtn?.addEventListener('click', () => {
    if (step > 1) {
      step -= 1;
      renderStep();
    }
  });

  resultBackBtn?.addEventListener('click', () => {
    hideResult();
    step = total;
    renderStep();
  });

  resetBtn?.addEventListener('click', () => {
    Object.keys(answers).forEach((key) => delete answers[key]);
    hideResult();
    step = 1;
    renderStep();
  });

  renderStep();
}

function initBackToStore() {
  document.querySelectorAll('[data-vy-back]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const referrer = document.referrer;
      if (!referrer) return;
      try {
        const previous = new URL(referrer);
        const sameHost = previous.host === window.location.host;
        const samePage = previous.href === window.location.href;
        if (sameHost && !samePage) {
          event.preventDefault();
          window.history.back();
        }
      } catch (e) {
        /* Follow the homepage link. */
      }
    });
  });
}

function initReviews(root) {
  const scroller = root.querySelector('[data-reviews-scroller]');
  const prev = root.querySelector('[data-reviews-prev]');
  const next = root.querySelector('[data-reviews-next]');
  const dots = root.querySelectorAll('[data-reviews-dot]');
  if (!scroller) return;

  const amount = () => {
    const card = scroller.querySelector('.vy-review-card, .vy-ba-card');
    if (!card) return scroller.clientWidth;
    const styles = window.getComputedStyle(scroller.querySelector('.vy-reviews__track, .vy-ba-results__track') || scroller);
    const gap = parseFloat(styles.columnGap || styles.gap) || 16;
    return card.getBoundingClientRect().width + gap;
  };

  const setActiveDot = () => {
    if (!dots.length) return;
    const step = amount();
    const i = step ? Math.round(scroller.scrollLeft / step) : 0;
    dots.forEach((dot, idx) => {
      dot.classList.toggle('is-active', idx === i);
    });
  };

  prev?.addEventListener('click', () => {
    scroller.scrollBy({ left: -amount(), behavior: 'smooth' });
  });
  next?.addEventListener('click', () => {
    scroller.scrollBy({ left: amount(), behavior: 'smooth' });
  });
  dots.forEach((dot, idx) => {
    dot.addEventListener('click', () => {
      scroller.scrollTo({ left: amount() * idx, behavior: 'smooth' });
    });
  });
  scroller.addEventListener('scroll', setActiveDot, { passive: true });
  setActiveDot();
}

function initTallowStickyCart() {
  const bar = document.querySelector('[data-pdp-sticky], [data-tallow-sticky]');
  const add = document.querySelector('[data-add-to-cart]');
  const stickyAdd = document.querySelector('[data-pdp-sticky-add], [data-tallow-sticky-add]');
  if (!bar || !add || !stickyAdd) return;
  if (window.matchMedia('(min-width: 781px)').matches) return;

  const sync = (visible) => {
    bar.hidden = visible;
    bar.classList.toggle('is-on', !visible);
  };
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => sync(entry.isIntersecting));
    }, { threshold: 0.2 });
    observer.observe(add);
  }
  stickyAdd.addEventListener('click', () => {
    if (add.disabled) return;
    add.click();
  });
}

